var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 -8 35 25",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.878,12.546a3.007,3.007,0,0,0,4.244,0l9.659-9.66A3,3,0,0,0,21,1H3A3,3,0,0,0,.219,2.886Z",
    fill: "#0c6cc5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.536,13.96a5.007,5.007,0,0,1-7.072,0L0,5.5V23H24V5.5Z",
    fill: "#0c6cc5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.8b2a1eb5bf7c34d2bfe4185abeffb0cc.svg";
export { ForwardRef as ReactComponent };